import Layout from "@/layout/Layout";
import globalStyle from "@/styles/Global.scss";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import {getUketoriCards} from "@/api/exchange";
import ImageCard from "@/components/ImageCard";
import MButton from "@/components/atom/MButton";

const UketoriList = () => {
  const history = useHistory()
  const [cardExchanges, setCardExchanges] = useState([])

  useEffect(() => {
    (async () => {
      const cardExchanges = await getUketoriCards()
      setCardExchanges(cardExchanges)
    })()
  }, [])

  const toUketoriDetail = (id) => {
    history.push(`/uketori/${id}`)
  }

  const toMenu = () => {
    history.push(`/menu`)
  }

  const toQR = () => {
    history.push(`/uketori/qr`)
  }

  return (
    <>
      <Layout category={'UK'} title={'受取名刺'}>
        <MButton image={'back.png'} value={'戻る'} onClick={toMenu}></MButton>
        <MButton image={'qr.png'} value={'QR撮影'} onClick={toQR}></MButton>
        <div className={globalStyle.container}>
          {
            cardExchanges.length === 0 && <>
              <div>まだ名刺を受け取っていません。</div>
            </>
          }
          {
            cardExchanges.map((c) => {
              return <React.Fragment key={c.id}>
                <div>
                  <ImageCard id={c.card.id} onClick={() => toUketoriDetail(c.id)}></ImageCard>
                  <hr className={globalStyle.separator} />
                </div>
              </React.Fragment>
            })
          }
        </div>
      </Layout>
    </>
  )
}

export default UketoriList
